<script lang="ts">
	import { appstates } from "./stores/app-state";
	import { APP_STATES } from "./models/app-states.enum";
	import StepProgress from "./components/common/advancement/step-progress.svelte";
	import ActionsComponent from "./components/main/actions/actions.component.svelte";
	import ActorsComponent from "./components/main/actors.component.svelte";
	import DatasComponent from "./components/main/datas.component.svelte";
	import EndComponent from "./components/main/end.component.svelte";
	import InitComponent from "./components/main/init.component.svelte";
	import QuestionsComponent from "./components/main/questions/questions.component.svelte";
	import StakeComponent from "./components/main/stake.component.svelte";
	import Card from "./components/ui/Card.svelte";
	import Footer from "./components/common/footer.svelte";

	const steps = [
		{
			number: APP_STATES.INIT,
			title: "Début",
			done: true,
			active: false,
			component: InitComponent,
		},
		{
			number: APP_STATES.STAKE,
			title: "Enjeux",
			done: true,
			active: false,
			component: StakeComponent,
		},
		{
			number: APP_STATES.ACTORS,
			title: "Acteurs",
			done: false,
			active: true,
			component: ActorsComponent,
		},
		{
			number: APP_STATES.DATAS,
			title: "Données",
			done: false,
			active: false,
			component: DatasComponent,
		},
		{
			number: APP_STATES.ACTIONS,
			title: "Actions",
			done: false,
			active: false,
			component: ActionsComponent,
		},
		{
			number: APP_STATES.QUESTIONS,
			title: "Questions",
			done: false,
			active: false,
			component: QuestionsComponent,
		},
		{
			number: APP_STATES.END,
			title: "Fin",
			done: false,
			active: false,
			component: EndComponent,
		},
	];

	$: selectedComponent = steps.filter((c) => c.number === $appstates)[0];
</script>

<main class="container">
	<StepProgress mode="horizontal" {steps}  selected={$appstates} />
	<Card>
		<svelte:component
			this={selectedComponent.component}
			title={selectedComponent.title}
		/>
	</Card>
	<Footer />
</main>

<style>

</style>
